import React, { useState, useContext, useEffect } from "react";
import Navbar from "../components/common/Navbar";
import ReactPaginate from "react-paginate";
import { AiOutlineSearch } from "react-icons/ai";
import TextField from "@mui/material/TextField";
import {
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import { AuthContext } from "../context/Auth/AuthContext";
import Table from "../components/bin/document-bin/Table";
import Loading from "../components/material-ui/Loading";
import binData from "../api/bin";
import baseUrl from "../config/baseUrl";
import "../styles/TrashDocuments.css";

const TrashDocuments = () => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [globalSearch, setGlobalSearch] = useState("");

  const [trashedDocuments, setTrashedDocuments] = useState([]);
  const { token, userID, isAdmin } = useContext(AuthContext);

  const [api, setApi] = useState(
    `${baseUrl}/apireact/alltrashdocument?limit=20&offset=0&isAdmin=${isAdmin}&user_id=${userID}`
  );

  const [documentRestored, setDocumentRestored] = useState(0);
  const [documentDeleted, setDocumentDeleted] = useState(0);

  let limit = 20;
  const offset = currentPage * limit;

  let global_search = globalSearch ? `&global_search=${globalSearch}` : "";

  const trashedDocumentsData = async () => {
    setLoading(true);
    const response = await binData({ token, api });
    setPageCount(Math.ceil(response?.allTrashDocsCount / limit));
    if (currentPage > Math.ceil(response?.allTrashDocsCount / limit)) {
      setCurrentPage(Math.ceil(response?.allTrashDocsCount / limit));
    }
    setTrashedDocuments(response?.data);
    setLoading(false);
  };

  useEffect(() => {
    trashedDocumentsData();
  }, [api, documentRestored, documentDeleted]);

  const setDocumentRestoredToTrue = (documentList) => {
    if (documentList) {
      currentPage === 0
        ? setCurrentPage((currentPage) => currentPage + 1)
        : setCurrentPage((currentPage) => currentPage - 1);
    }
    setDocumentRestored((count) => count + 1);
  };

  const setDocumentDeletedToTrue = (documentList) => {
    setDocumentDeleted((count) => count + 1);
  };

  useEffect(() => {
    setApi(
      `${baseUrl}/apireact/alltrashdocument?limit=${limit}&offset=${offset}${global_search}&isAdmin=${isAdmin}&user_id=${userID}`
    );
  }, [currentPage]);

  useEffect(() => {
    const debounceFn = setTimeout(() => {
      setCurrentPage(0);
      setApi(
        `${baseUrl}/apireact/alltrashdocument?limit=${20}&offset=${0}${global_search}&isAdmin=${isAdmin}&user_id=${userID}`
      );
    }, 2500);

    return () => clearTimeout(debounceFn);
  }, [globalSearch]);

  const onGlobalSearchChange = (e) => {
    setGlobalSearch(e.target.value);
  };

  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  };

  return (
    <div className="trash-container">
      <div className="navbar">
        <Navbar />
      </div>
      <div className="trash-document-content">
        <div className="trash-document-table-header">
          <TextField
            name="globalSearch"
            label="Search"
            type="text"
            autoComplete="off"
            value={globalSearch}
            onChange={onGlobalSearchChange}
            variant="outlined"
            InputProps={{
              endAdornment: <AiOutlineSearch />,
            }}
          />
        </div>
        {!loading ? (
          trashedDocuments.length > 0 ? (
            <div>
              <Table
                loading={loading}
                setDocumentRestoredToTrue={setDocumentRestoredToTrue}
                setDocumentDeletedToTrue={setDocumentDeletedToTrue}
                trashedDocuments={trashedDocuments}
              />
              <div className="trash-document-table-pagination">
                <ReactPaginate
                  previousLabel={<MdOutlineArrowBackIos />}
                  nextLabel={<MdOutlineArrowForwardIos />}
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  forcePage={currentPage}
                  containerClassName={"trash-pagination"}
                  previousLinkClassName={"trash-pagination-link"}
                  nextLinkClassName={"trash-pagination-link"}
                  disabledClassName={"trash-pagination-link-disabled"}
                  activeClassName={"trash-pagination-link-active"}
                />
              </div>
            </div>
          ) : (
            <h5 className="no-trash-document-data">No Data Available</h5>
          )
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default TrashDocuments;
